import type { Langs } from '@CS/components/TranslationProvider/types';
type LocalizedImages = Record<string, Record<Langs, string>>;

export const capitalize = (s: string): string =>
  s.charAt(0).toLocaleUpperCase() + s.slice(1);

export const camelCase = (str: string): string =>
  str
    .split(' ')
    .map(str => str.toLocaleLowerCase())
    .map((str, s) => (s && capitalize(str)) || str)
    .join('');

export const flatLocalizedImages = (images: LocalizedImages) =>
  Object.entries(images).reduce((images, [name, image]) => {
    for (const [lang, path] of Object.entries(image))
      Object.assign(images, { [`${name}${lang}`]: path });

    return images;
  }, {});
